module.exports = require("next/dist/server/app-render/work-unit-async-storage.external.js");